export const taskStatuses = {
    pending: 'В работе',
    done: 'Выполнена',
    cancel: 'Отменена'
};